import queryString, { ParsedQuery } from "query-string";

export type URL = {
	pathname: string;
	search: string;
	hash: string;
};

export type LocationData = {
	url: URL;
	pathname: string;
	query: ParsedQuery<string>;
};

export const createLocationData = (url?: URL): LocationData => {
	return {
		url: url ?? {
			hash: window.location.hash,
			pathname: window.location.pathname,
			search: window.location.search,
		},

		get pathname() {
			return this.url.pathname;
		},

		get query(): ParsedQuery {
			const { search, hash } = this.url;
			const searchQuery: ParsedQuery = queryString.parse(search);
			const hashQuery: ParsedQuery = queryString.parse(hash);
			return {
				...searchQuery,
				...hashQuery,
			};
		},
	};
};
